<template>
  <div
    class="dis-cla-compo"
  >
    <p
      class="flx-ctr"
      style="width: 100%;height: 100%;z-index:1002;position: relative;"
      @click="toggleShow"
    >
      温馨提醒
    </p>
    <van-overlay
      :show="showDialog"
      @click="showDialog = false"
    >
      <div
        class="dialog animated0d5s fadeIn"
      >
        <div
          class="content flx-ctr"
          :style="{top: options.contentTop}"
        >
          <van-image
            :src="content"
            width="8rem"
            :show-error="false"
            :show-loading="false"
          >
            <van-image
              width="30%"
              class="abs-b"
              style="left: 35%;bottom: 5%"
              :src="require('@/imgs/index/disclaimer/btn.png')"
              :show-error="false"
              :show-loading="false"
              @click="showDialog=false"
            />
          </van-image>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { DISCLAIMER_TEXT } from '@/libs/config/index';
import { Overlay } from 'vant';

export default {
  components: {
    [Overlay.name]: Overlay,
  },
  props: {
    content: {
      type: String,
      default: () => (require('@/imgs/index/disclaimer/bg.png')),
    },
    options: {
      type: Object,
      default: () => ({
        contentTop: '20vh',
        isFirstOpen: true,
      }),
    },
  },
  data() {
    return {
      text: DISCLAIMER_TEXT,
      showDialog: false,
    };
  },
  created() {
    this.showDialog = this.options.isFirstOpen;
  },
  methods: {
    toggleShow() {
      const { showDialog } = this;
      this.showDialog = !showDialog;
    },
  },
};
</script>

<style lang="less" scoped>
.dis-cla-compo{
  width: 60px;
  height: 20px;
  background: #000000;
  border: .5px solid #CDA36E;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 400;
  color: #E6E6E6;
  .dialog {
    position: fixed;
    z-index: 1001;
    width: 10rem;
    height: 100vh;
    top: 0;
    left: 0;
    .content {
      position: absolute;
      top: 20vh;
      left: 1rem;
      border-radius: 5px;
    }
  }
}
</style>
